import { Component } from '@angular/core';
import { CustomModalService } from '@piqet-angular/shared';
import { MyOrganizationService } from 'libs/data/src/lib/services/my-organization/my-organization.service';

interface ImportErrorData {
  error?: {
    errorDetails?: string[];
    errorType?: number;
    errorMessage?: string;
  };
  duplicateEmails?: string[];
  errorMessage?: string;
  errorType?: number;
  fileName?: string;
  importDate?: string;
  importBatchId?: number;
  importStatus?: number;
}

@Component({
  selector: 'piqet-angular-import-user-error',
  templateUrl: './import-user-error.component.html',
  styleUrls: ['./import-user-error.component.scss'],
})
export class ImportUserErrorComponent {
  errorData: any = {};

  constructor(
    private modal: CustomModalService,
    private myOrganizationService: MyOrganizationService
  ) {
    this.errorData = this.modal?.modalService?.config?.initialState?.['errorData'];
  }

  // Helper method to get duplicate emails from either structure
  getDuplicateEmails(): string[] {
    return this.errorData?.duplicateEmails || this.errorData?.error?.errorDetails || [];
  }

  // Helper method to get error message
  getErrorMessage(): string {
    return this.errorData?.error?.errorMessage || this.errorData?.errorMessage || '';
  }

  onClose(): void {
    this.myOrganizationService
      .updateAcknowledgeImportError(this.errorData?.importBatchId)
      .subscribe(() => {
        this.modal.close();
      });
  }
}
